<template>
  <ContentWrapperControl class="mt-4">
    <div v-if="!loading">
      <div
        v-if="all_banks.length === 0 && !eft_closed"
        class="flex flex-col items-center justify-center text-center text-gray-500 py-8 bg-white rounded-lg shadow"
      >
        <img :src="this.getEmptyIcon()" class="w-16 h-16 object-contain mb-3" />
        <div class="flex flex-col px-8">
          <span class="font-semibold mt-4">{{ lang("lbl_0000312") }}</span>
          <span class="text-sm mt-4 text-justify">{{
            lang("lbl_0000313")
          }}</span>
        </div>
      </div>
      <div
        v-if="
          (all_banks.length > 0 && !has_read_tnc && eft_closed) ||
          (all_banks.length === 0 && eft_closed)
        "
        class="flex flex-col items-center justify-center text-center text-gray-600 p-4 bg-white rounded-lg shadow-md"
      >
        <div
          class="bg-info-light rounded-lg w-full max-w-xl shadow-sm text-info-text border-l-8"
          style="border-color: #2563eb"
        >
          <div class="flex flex-col px-6 py-5 text-left">
            <span
              class="leading-normal text-sm mt-3 text-gray-700 text-justify"
            >
              Thank you for your interest in applying for the EFT for your
              Patronage Refund and Interest in Share Capital (Dividend).
            </span>

            <span
              class="leading-normal text-sm mt-3 text-gray-700 text-justify"
            >
              However, Electronic Fund Transfer for Dividends scheduled for
              February 2026 will be
              <span class="uppercase font-semibold">postponed</span> until
              further notice. The application for EFT-Patronage Refund is
              expected to reopen later this year.
            </span>

            <span
              class="leading-normal text-sm mt-3 text-gray-700 text-justify"
            >
              Kindly wait for further announcements here in the membership
              portal and through our official channels.
            </span>

            <span
              class="leading-normal text-sm mt-3 text-gray-700 text-justify"
            >
              We appreciate your patience and understanding.
            </span>
          </div>
        </div>
      </div>
      <div v-else-if="all_banks.length > 0 && has_read_tnc">
        <div class="mb-4 text-xs font-semibold text-grey-darker text-right">
          Read the
          <span class="underline" @click="show_optional_terms = true"
            >Terms and Conditions</span
          >
        </div>
        <div
          class="flex flex-col w-full min-w-0 overflow-hidden text-left text-gray-500 bg-white rounded-lg shadow"
        >
          <SettingCardControl
            class="w-full min-w-0"
            v-for="bank in all_banks"
            :key="getBankId(bank)"
            :title="bank.bank_name.trim()"
            :value="bank.bank_act_no"
            :dropdown="false"
            :shadow="false"
            :icon="this.getPNBLogo()"
            :show_border="false"
            :show_bottom_margin="false"
          >
            <SettingCardItemControl
              v-for="(sub, i) in getVisibleSubs(bank)"
              :key="i"
              :title="sub.subscription_name.replace(/^EFT - /, '')"
              :show_border="i !== getVisibleSubs(bank).length - 1"
            >
              <div class="flex justify-end items-center w-full">
                <span
                  class="text-xs mr-2 text-right"
                  :class="
                    sub.subscription_status ? 'text-primary font-semibold' : ''
                  "
                >
                  {{ sub.subscription_status ? "Subscribed" : "Unsubscribed" }}
                </span>

                <SwitchControl
                  :checked="sub.subscription_status"
                  type="EFT"
                  @toggle="(newStatus) => handleToggle(sub, bank, newStatus)"
                  :disabled="eft_closed || eft_disabled"
                />
              </div>
            </SettingCardItemControl>
            <div
              class="flex flex-col items-center w-full mt-2"
              v-if="!this.eft_closed && !this.eft_disabled"
            >
              <ButtonControl
                v-if="false"
                :outline="true"
                class="w-full"
                @click="toggleAll(bank)"
                :disabled="eft_closed"
              >
                {{ getToggleAllLabel(bank) }}
              </ButtonControl>

              <ButtonControl
                class="w-full"
                :disabled="
                  !bank.member_subcription.some((sub) => sub.is_changed) ||
                  eft_closed
                "
                @click="buttonClick(bank)"
              >
                {{ this.lang("lbl_0000307") }}
              </ButtonControl>
            </div>
          </SettingCardControl>
        </div>
      </div>
    </div>
  </ContentWrapperControl>

  <EFTTermsControl
    v-if="show_terms"
    :show="show_terms"
    :show_agree="true"
    @closed="onGlobalTermsClosed"
    @agreed="onGlobalTermsAgreed"
  />

  <EFTTermsControl
    v-if="show_bank_terms"
    :show="show_bank_terms"
    :show_agree="true"
    @closed="onTermsClosed"
    @agreed="onTermsAgreed"
  />

  <EFTTermsControl
    v-if="show_optional_terms"
    :show="show_optional_terms"
    :show_agree="false"
    @closed="onOptionalTermsClosed"
  />

  <ModalControl
    v-if="show_pin"
    :show="show_pin"
    @closed="onPinClosed"
    title="Enter PIN"
    dismiss
  >
    <PinControl
      :key="show_pin"
      :label="lang('lbl_0000032')"
      :value="pin_value"
      @complete="onPinValidated"
    />
  </ModalControl>

  <ModalControl
    :show="
      all_banks.length > 0 && has_read_tnc && eft_closed && !show_info_closed
    "
    title="Information"
    theme="info"
  >
    <div class="flex flex-col text-left items-center p-2">
      <img src="@/assets/icons/papsi_info_blue.svg" class="my-3 w-modal-icon" />
      <span class="leading-normal text-sm mt-3 text-gray-700 text-justify">
        Thank you for your interest in applying for the EFT for your Patronage
        Refund and Interest in Share Capital (Dividend).
      </span>

      <span class="leading-normal text-sm mt-3 text-gray-700 text-justify">
        However, Electronic Fund Transfer for Dividends scheduled for February
        2026 will be
        <span class="leading-normal font-semibold uppercase">postponed</span>
        until further notice. The application for EFT-Patronage Refund is
        expected to reopen later this year.
      </span>

      <span class="leading-normal text-sm mt-3 text-gray-700 text-justify">
        Kindly wait for further announcements here in the membership portal and
        through our official channels.
      </span>

      <span class="leading-normal text-sm mt-3 text-gray-700 text-justify">
        We appreciate your patience and understanding.
      </span>
    </div>
    <ButtonControl class="mt-4" @click="show_info_closed = true" theme="info">
      {{ this.lang("lbl_0000349") }}
    </ButtonControl>
  </ModalControl>
</template>

<script>
import ContentWrapperControl from "./../../components/controls/ContentWrapperControl.vue";
import SettingCardControl from "./../../components/controls/SettingCardControl.vue";
import SettingCardItemControl from "./../../components/controls/SettingCardItemControl.vue";
import SwitchControl from "@/components/controls/SwitchControl.vue";
import ButtonControl from "@/components/controls/ButtonControl.vue";
import EFTTermsControl from "@/components/controls/EFTTermsControl.vue";
import PinControl from "@/components/controls/PinControl.vue";
import ModalControl from "@/components/controls/ModalControl.vue";
import Services from "@/services/Services";
import User from "@/services/User.js";
import mixin from "./../../mixin.js";

export default {
  mixins: [mixin],
  emits: [
    "checkauth",
    "shownavbar",
    "nofooter",
    "showloader",
    "hideloader",
    "success",
    "error",
    "closed",
    "agreed",
    "alert",
    "login",
    "logout",
    "showblinder",
    "hideblinder",
    "terminate",
    "hidenavbar",
    "opensidebar",
  ],
  components: {
    ContentWrapperControl,
    SettingCardControl,
    SettingCardItemControl,
    EFTTermsControl,
    SwitchControl,
    ButtonControl,
    PinControl,
    ModalControl,
  },
  watch: {
    show_pin(newVal) {
      if (newVal) {
        this.pin_value = "";
      }
    },
  },
  data() {
    return {
      loading: true,
      all_banks: [],
      hide: ["SVC0000002"],
      show_terms: false,
      show_bank_terms: false,
      show_optional_terms: false,
      active_bank: null,
      pending_status: null,
      show_pin: false,
      pin_value: "",
      has_read_tnc: true,
      eft_closed: false,
      show_info_closed: false,
      pending_bank_key: null,
      bank_acct_c: null,
      bank_acct_s: null,
      pending_bank: null,
      eft_disabled: false,
    };
  },
  mounted() {
    this.$emit("showloader");
    this.$emit("checkauth");

    this.$emit("shownavbar", {
      title: this.lang("lbl_0000297"),
      show: true,
      back: true,
    });

    this.$emit("nofooter", false);

    const stored_banks = this.$store.state.eft?.banks;
    const banks_fetched = this.$store.state.eft?.banks_fetched;

    if (banks_fetched) {
      this.all_banks = JSON.parse(JSON.stringify(stored_banks || []));

      this.has_read_tnc = this.all_banks.every((bank) => bank.has_read_tnc);

      if (this.eft_disabled) {
        this.has_read_tnc = true;
      } else if (!this.has_read_tnc && !this.eft_closed) {
        this.show_terms = true;
      }

      this.$emit("hideloader");
      this.loading = false;
      return;
    }

    Services.getBanks()
      .then((response) => {
        const data = response.data.data;
        const banks = this.normalizeBanks(data);

        this.$store.state.eft.banks = JSON.parse(JSON.stringify(banks));
        this.$store.state.eft.banks_fetched = true;

        this.all_banks = JSON.parse(JSON.stringify(banks));

        const all_read_tnc = banks.every((bank) => bank.has_read_tnc);

        this.has_read_tnc = all_read_tnc;

        if (this.eft_disabled) {
          this.has_read_tnc = true;
        } else if (!this.has_read_tnc && !this.eft_closed) {
          this.show_terms = true;
        }
      })
      .catch((error) => {
        this.$emit("error", error);
      })
      .finally(() => {
        this.$emit("hideloader");
        this.loading = false;
      });
  },
  computed: {
    banksWithChanges() {
      return this.all_banks.map((bank) => ({
        ...bank,
        hasChanges: bank.member_subcription.some((sub) => sub.is_changed),
      }));
    },
  },
  methods: {
    getPNBLogo() {
      const path = "logo/";
      const file_name = "pnb_papsi.png";
      if (process.env.VUE_APP_CDN_URL) {
        return process.env.VUE_APP_CDN_URL + path + file_name;
      }
    },

    getEmptyIcon() {
      const path = "icons/";
      const file_name = "papsi_empty.png";
      if (process.env.VUE_APP_CDN_URL) {
        return process.env.VUE_APP_CDN_URL + path + file_name;
      }
    },

    getVisibleSubs(bank) {
      return bank.member_subcription.filter(
        (s) => !this.hide.includes(s.subscription_key),
      );
    },

    onGlobalTermsAgreed() {
      this.show_terms = false;
      this.show_bank_terms = false;
      // this.show_pin = false;
      this.has_read_tnc = true;
    },

    onGlobalTermsClosed() {
      this.show_terms = false;
      this.$router.push("/dashboard");
    },

    toggleAll(bank) {
      const all_on = bank.member_subcription.every(
        (sub) => sub.subscription_status === true,
      );

      bank.member_subcription.forEach((sub) => {
        sub.subscription_status = !all_on;
        sub.is_changed = sub.subscription_status !== sub.original_status;
      });
    },

    getToggleAllLabel(bank) {
      const all_on = bank.member_subcription.every(
        (sub) => sub.subscription_status === true,
      );
      return all_on ? this.lang("lbl_0000311") : this.lang("lbl_0000308");
    },

    getBankId(bank) {
      return `${bank.bank_key}_${bank.bank_acct_c || ""}_${
        bank.bank_acct_s || ""
      }`;
    },

    handleToggle(sub, bank, newStatus) {
      sub.subscription_status = newStatus;
      sub.is_changed = sub.subscription_status !== sub.original_status;
    },

    buttonClick(bank) {
      // this.pending_bank = bank;

      // if (!this.has_read_tnc) {
      //   this.show_bank_terms = true;
      //   return;
      // }

      // this.pin_value = "";
      // this.show_pin = true;
      // this.show_bank_terms = false;

      this.pending_bank = bank;

      this.show_pin = false;

      if (!this.has_read_tnc) {
        this.show_bank_terms = true;
        return;
      }

      this.show_bank_terms = false;

      this.pin_value = "";
      this.show_pin = true;
    },

    onTermsAgreed() {
      // this.show_terms = false;
      // this.show_bank_terms = false;
      // this.pending_status = null;
      // this.pin_value = "";

      this.show_terms = false;
      this.show_bank_terms = false;
      this.has_read_tnc = true;

      this.show_pin = false;
    },

    onTermsClosed() {
      this.show_bank_terms = false;
      this.pending_status = null;
    },

    onOptionalTermsClosed() {
      this.show_optional_terms = false;
    },

    onPinClosed() {
      // this.show_pin = false;
      // this.pin_value = "";
      // this.pending_bank = null;

      this.show_pin = false;
      this.pin_value = "";
      this.pending_bank = null;

      this.show_bank_terms = false;
    },

    async onPinValidated(pin) {
      this.$emit("showloader");

      try {
        const uuid = this.$store.state.uuid;
        await User.validatePin(uuid, pin);

        this.show_pin = false;

        this.pin_value = "";

        this.subscribe(this.pending_bank);

        this.pending_bank = null;
      } catch (error) {
        this.$emit("hideloader");
        this.pin_value = "";

        if (this.pending_bank_key) {
          const bank_index = this.all_banks.findIndex(
            (b) => this.getBankId(b) === this.getBankId(this.pending_bank),
          );

          if (bank_index !== -1) {
            const bank = this.all_banks[bank_index];

            const restored_subs = bank.member_subcription.map((sub) => ({
              ...sub,
              subscription_status: sub.original_status,
              is_changed: false,
            }));

            this.$set
              ? this.$set(
                  this.all_banks[bank_index],
                  "member_subcription",
                  restored_subs,
                )
              : (this.all_banks[bank_index].member_subcription = restored_subs);
          }
        }
        this.$emit("error", error);
        this.show_pin = false;
        this.pending_bank = null;
      }
      // finally {
      //   this.$emit("hideloader");
      // }
    },

    subscribe(bank) {
      if (!bank) return;

      const changed_subscriptions = bank.member_subcription
        .filter((sub) => sub.is_changed)
        .map((sub) => sub.subscription_key);

      if (changed_subscriptions.length === 0) return;

      const payload = {
        bank_key: bank.bank_key,
        subscription_key: changed_subscriptions,
        bank_acct_c: bank.bank_acct_c,
        bank_acct_s: bank.bank_acct_s,
      };

      this.$emit("showloader");

      Services.subscribeEFT(payload)
        .then(() => {
          bank.member_subcription.forEach((sub) => {
            sub.is_changed = false;
            sub.original_status = sub.subscription_status;
          });

          this.$store.state.eft.banks = JSON.parse(
            JSON.stringify(this.all_banks),
          );

          this.$emit("success", this.lang("lbl_0000306"));
        })
        .catch((error) => {
          this.$emit("error", error);
        })
        .finally(() => {
          this.$emit("hideloader");
        });
    },

    normalizeBanks(data) {
      const banks = Array.isArray(data) ? data : [data];

      return banks
        .map((bank) => {
          if (!bank || typeof bank !== "object") return null;

          return {
            bank_name: bank.bank_name || "Bank Name",
            bank_act_no: bank.bank_act_no || "",
            bank_key: bank.bank_key || "",
            has_read_tnc: !!bank.has_read_tnc,
            bank_acct_c: bank.bank_acct_c || null,
            bank_acct_s: bank.bank_acct_s || null,
            member_subcription: Array.isArray(bank.member_subcription)
              ? bank.member_subcription.map((sub) => ({
                  ...sub,
                  is_changed: false,
                  original_status: sub.subscription_status,
                }))
              : [],
          };
        })
        .filter((b) => b !== null);
    },
  },
};
</script>
